import MarqueeBase from '#BASE/components/home/marquee.component';

export default {
    mixins: [MarqueeBase],
    computed: {
        seamlessScrollOption() {
            let _listLength = this.List.length;
            return {
                step: 1,                        //数值越大速度滚动越快
                limitMoveNum: _listLength,      //开始无缝滚动的数据量
                hoverStop: false,                //是否开启鼠标悬停stop
                direction: 1,                   // 0向下 1向上 2向左 3向右
                // openWatch: true,                //开启数据实时监控刷新dom
                singleHeight: 30,
                waitTime: 5000,
            }
        }
    }
};
